export default "__VITE_ASSET__EbXvnZ$P__"